import { api } from '../../core/api.js';
import { toast } from '../../components/toast.js';
import {
  sameOriginUploadUrl,
  needsAuthedUpload,
  downloadProtectedUpload,
} from '../../components/markdown.js';

async function download(file) {
  const href = sameOriginUploadUrl(file && file.url);
  if (!href || href.charAt(0) !== '/') throw new Error('No file to download');
  if (needsAuthedUpload(href)) {
    await downloadProtectedUpload(href);
    return;
  }
  const link = document.createElement('a');
  link.href = href;
  link.download = file.name || 'bonnie-export';
  link.rel = 'noopener';
  document.body.append(link);
  link.click();
  link.remove();
}

/**
 * Save as document (`md`) or PDF. The server builds the file; a missing PDF
 * engine still returns Markdown so the person gets something they can keep.
 */
export async function exportMessage(messageId, format, buttonNode) {
  if (buttonNode) buttonNode.disabled = true;
  try {
    const res = await api('/chat/export', {
      method: 'POST',
      body: { messageId, format: format === 'pdf' ? 'pdf' : 'md' },
    });
    if (!res || res.error) throw new Error((res && res.error) || 'Export failed');
    if (format === 'pdf') {
      if (res.pdf && res.pdf.url) {
        download(res.pdf);
        return;
      }
      if (res.md && res.md.url) {
        download(res.md);
        toast(res.pdf_error || 'PDF unavailable — downloaded Markdown instead');
        return;
      }
      throw new Error(res.pdf_error || 'No PDF file returned');
    }
    if (!res.md || !res.md.url) throw new Error('No Markdown file returned');
    download(res.md);
    toast('Saved as a document');
  } catch (err) {
    toast((err && err.message) || 'Export failed', 'error');
  } finally {
    if (buttonNode) buttonNode.disabled = false;
  }
}

export async function archiveChat(groupId) {
  const res = await api(`/chat/${encodeURIComponent(groupId)}`, { method: 'DELETE' });
  if (!res || res.error) throw new Error((res && res.error) || 'Could not archive this chat');
  return res;
}
